import { getCurrentStationId } from '@spx-portal/shared-utils';

import { request } from '@/common/appCtx';

import { createSelectors } from './constructor/createSelectors';
import { createStore } from './constructor/createStore';

type State = {
  grayStationData: {
    // 是否屏蔽disable页面，市场维度
    hide_slot_disable_page: boolean;
    // 是否屏蔽station创建shift页面，市场维度
    station_create_shift_toggle: boolean;
    // 最大跨天数
    shift_max_cross_day: number;
  };
};

type Action = {
  checkGrayStation: () => Promise<void>;
};

const DEFAULT_SHIFT_MAX_CROSS_DAY = 6;

export const useCheckGrayStation = createSelectors(
  createStore<State & Action>((set) => ({
    grayStationData: {
      hide_slot_disable_page: false,
      station_create_shift_toggle: false,
      shift_max_cross_day: DEFAULT_SHIFT_MAX_CROSS_DAY,
    },
    checkGrayStation: async () => {
      const params = {
        station_id: getCurrentStationId(),
      };
      const res = await request.get('/api/wfm/common/check_gray_station', { params });
      set(() => ({ grayStationData: res.data }));
    },
  }))
);
